import { z } from 'zod';
import { requiredString } from '../helpers';
export const Chat_Handoff_2_ConfigValidator = z.object({
    destinationAgentId: requiredString('Destination agent is required'),
    destinationLabelId: z.string().nullable().optional()
});
//# sourceMappingURL=chat-handoff-2.js.map